import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Applications", -1)
const _hoisted_2 = { class: "pa-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-disabled font-weight-regular" }, "You do not have access to any applications.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      class: "pt-2 mx-4",
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            (!_ctx.applications.length && !_ctx.loaded)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        (_ctx.applications.length && _ctx.loaded)
          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applications, (app) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: app.id,
                    cols: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        height: "230",
                        elevation: "0",
                        color: "primary",
                        variant: "tonal",
                        class: "d-flex flex-column fill-height justify-space-between"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "3" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_avatar, {
                                      size: "50",
                                      color: "secondary",
                                      rounded: "",
                                      class: "mx-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(app.name.charAt(0)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { cols: "9" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { class: "text-capitalize font-weight-bold text-body-1 pt-5 text-wrap name-height" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(app.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_subtitle, { class: "text-capitalize" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(app.type), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      (app.description?.length > 30)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.truncate(app.description)), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(app.description), 1))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_actions, { class: "px-4" }, {
                            default: _withCtx(() => [
                              (_ctx.userStore.hasPermission('application:manage'))
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    to: `/applications/${app.id}/configuration`
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        start: "",
                                        icon: "mdi-application-cog-outline"
                                      }),
                                      _createTextVNode("Configure")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                to: `/applications/${app.id}`,
                                disabled: !(_ctx.userStore.user?.applications.map((a) => a.id).includes(Number(app.id)) || _ctx.userStore.hasPermission('administration:read'))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    start: "",
                                    icon: "mdi-application-export"
                                  }),
                                  _createTextVNode("Access")
                                ]),
                                _: 2
                              }, 1032, ["to", "disabled"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : (!_ctx.applications.length && _ctx.loaded)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}